export interface InteractiveLoginRequest {
  reason: 'token-unavailable' | 'unauthorized';
}

type Listener = (request: InteractiveLoginRequest) => void;
const listeners = new Set<Listener>();
let pendingRequest: InteractiveLoginRequest | null = null;

/**
 * Signals that an interactive login is required without navigating. The
 * AuthenticationController is the sole consumer that may start Auth0.
 */
export function requestInteractiveLogin(request: InteractiveLoginRequest): void {
  pendingRequest = request;
  listeners.forEach((listener) => listener(request));
}

export function subscribeToInteractiveLogin(listener: Listener): () => void {
  listeners.add(listener);
  if (pendingRequest) listener(pendingRequest);
  return () => listeners.delete(listener);
}

export function clearInteractiveLoginRequest(): void {
  pendingRequest = null;
}
